import { render, staticRenderFns } from "./LanguageRow.vue?vue&type=template&id=234752b2&"
import script from "./LanguageRow.vue?vue&type=script&lang=js&"
export * from "./LanguageRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports